;(function($, undefined) {
	/**
	 * View model constructor for Candidate Skills
	 */
	app.registerConstructor("CandidateSkills", function() {
		var self = this
		//To be initialized in page
		self.parentLoadingIcon = ko.observable()

		//To be initialized in page
		self.sid = {
				rasp: ko.observable(),
				company: ko.observable()
			}
		//To be initialized in page
		self.filterVisible = {
			competencies: ko.observable(true),
			qualifications: ko.observable(true),
			companies: ko.observable(true),
            talentManagement: ko.observable(true),
			boards: ko.observable(true)
		}

		//To be initialized in page
		self.resourcePath = ko.observable("")

		self.safeParentLoadingIcon = ko.pureComputed(function() {
			return self.parentLoadingIcon() || {
				show: _.noop,
				hide: _.noop
			}
		})
		
		self.workHistoryModal = {
			frameSrc: ko.observable(""),
			onHide: function() {
				self.workHistoryModal.frameSrc("about:blank")
				self.modal.blockUI(false)
			},
			onShow: function() {
				self.modal.blockUI(true)
			}
		}
		self.workHistoryModal.frameSrc.subscribe(function(newValue) {
			if (app.utils.trimString(newValue) && newValue != "about:blank") {
				try {
                    $('#editWorkHistoryFrame').squirt(
                        '<h4 style="text-align: center;font-family:arial;font-size:12px"> Loading ...</h4>');
				} catch (ignored) {}
			}
		})
		
		self.modal = {
            blockUI: ko.observable(false),
            reposition: function(widget) {
            	if (widget.jq) {
            		widget = widget.jq
            	} else {
            		widget = $(widget)
            	}
            	widget.css("top", ~~($(document).scrollTop() + $(window).height() / 2) - widget.height() / 2)
            }
		}

		self.openMailTo = function(e) {
			var email = "support@springboard.com.au";
			var subject = "Springboard upgrade request - Populate from Resume";
			var mailto_link = 'mailto:' + email + '?subject=' + subject;
			var body_message =
				"Hi,%0A%0AI would like to upgrade our Springboard account to include the 'Populate from Resume' module.%0A%0AThanking you"
			var mailto_link = 'mailto:' + email + '?subject=' + subject + '&body=' + body_message;
			win = window.open(mailto_link, 'emailWindow');
			if (win && win.open && !win.closed) win.close();
			e.preventDefault()
			return false;
		}

		self.repositionPaginationIcon = function() {
			$('.companiesPanel .companiesTable .ui-paginator-prev').css('top', $(
				'.companiesPanel .companiesTable .ui-datatable-tablewrapper').height() / 2);
			$('.companiesPanel .companiesTable .ui-paginator-next').css('top', $(
				'.companiesPanel .companiesTable .ui-datatable-tablewrapper').height() / 2);

			$('.qualificationsPanel .qualificationsTable .ui-paginator-prev').css('top', $(
				'.qualificationsPanel .qualificationsTable .ui-datatable-tablewrapper').height() / 2);
			$('.qualificationsPanel .qualificationsTable .ui-paginator-next').css('top', $(
				'.qualificationsPanel .qualificationsTable .ui-datatable-tablewrapper').height() / 2);

			$('.competenciesPanel .competenciesTable .ui-paginator-prev').css('top', $(
				'.competenciesPanel .competenciesTable .ui-datatable-tablewrapper').height() / 2);
			$('.competenciesPanel .competenciesTable .ui-paginator-next').css('top', $(
				'.competenciesPanel .competenciesTable .ui-datatable-tablewrapper').height() / 2);

			$('.boardsPanel .boardsTable .ui-paginator-prev').css('top', $(
				'.boardsPanel .boardsTable .ui-datatable-tablewrapper').height() / 2);
			$('.boardsPanel .boardsTable .ui-paginator-next').css('top', $(
				'.boardsPanel .boardsTable .ui-datatable-tablewrapper').height() / 2);
		}


		self.showHideFilters = function(sectionName) {
			if (sectionName == 'competenciesPanel') {
				if (self.filterVisible.competencies()) {
					//Show filter if checked
					$("." + sectionName + " .ui-column-filter").css("display", "block");
					self.updateNav(sectionName);
				} else {
					//Hide & clear filter if unchecked
					$("." + sectionName + " .ui-column-filter").css("display", "none");
					self.updateNav(sectionName);
				}
			}

			if (sectionName == 'qualificationsPanel') {
				if (self.filterVisible.qualifications()) {
					//Show filter if checked
					$("." + sectionName + " .ui-column-filter").css("display", "block");
					self.updateNav(sectionName);
				} else {
					//Hide & clear filter if unchecked
					$("." + sectionName + " .ui-column-filter").css("display", "none");
					self.updateNav(sectionName);
				}
			}

			if (sectionName == 'companiesPanel') {
				if (self.filterVisible.companies()) {
					//Show filter if checked
					$("." + sectionName + " .ui-column-filter").css("display", "block");
					self.updateNav(sectionName);
				} else {
					//Hide & clear filter if unchecked
					$("." + sectionName + " .ui-column-filter").css("display", "none");
					self.updateNav(sectionName);
				}
			}
			if (sectionName == 'boardsPanel') {

				if (self.filterVisible.boards()) {

					//Show filter if checked
					$("." + sectionName + " .ui-column-filter").css("display", "block");
					self.updateNav(sectionName);
				} else {
				
					//Hide & clear filter if unchecked
					$("." + sectionName + " .ui-column-filter").css("display", "none");
					self.updateNav(sectionName);
				}			
			}

            if (sectionName == 'talentManagementPanel') {
                if (self.filterVisible.talentManagement()) {
                    //Show filter if checked
                    $("." + sectionName + " .ui-column-filter").css("display", "block");
                    self.updateNav(sectionName);
                } else {
                    //Hide & clear filter if unchecked
                    $("." + sectionName + " .ui-column-filter").css("display", "none");
                    self.updateNav(sectionName);
                }
            }
		}

		self.cancelEditWorkHistoryRow = function() {
			PF('editWorkHistoryModal').hide();
		}

		self.saveEditWorkHistoryRow = function() {
			self.ajaxStarted();
		}

		self.ajaxStarted = function(opts) {
			self.safeParentLoadingIcon().show("", opts);
		}

		self.ajaxFinished = function() {
			self.safeParentLoadingIcon().hide();
		}

		self.finishEditWorkHistoryRow = function(msg) {
			remoteRefreshCompanyRelationships([{
				name: 'message',
				value: msg
			}]);
			PF('editWorkHistoryModal').hide();
		}

		self.showEditWorkHistoryRow = function(rowId) {
			self.workHistoryModal.frameSrc("/rasp-companies/includes/companies/contact/edit-relationship.seam;jsessionid=" +
				self.sid.company() + "?sessionId=" + self.sid.rasp() + "&from=tab&rId=" + rowId)
			PF('editWorkHistoryModal').show();
		}

		self.showAddWorkHistoryRow = function(candId) {
			self.workHistoryModal.frameSrc("/rasp-companies/includes/companies/contact/edit-relationship.seam;jsessionid=" +
				self.sid.company() + "?sessionId=" + self.sid.rasp() + "&from=tab&candId=" + candId)
			PF('editWorkHistoryModal').show();
		}
		
		self.updateCompNav = function() {
			$('.companiesPanel .companiesTable .ui-paginator-prev').css('top', $(
				'.companiesPanel .companiesTable .ui-datatable-tablewrapper').height() / 2);
			$('.companiesPanel .companiesTable .ui-paginator-next').css('top', $(
				'.companiesPanel .companiesTable .ui-datatable-tablewrapper').height() / 2);
		}

		self.showActionButtons = function() {
			$('.actionButtons').css("display", "inline-block");
			$('body').find('td.actions .ui-icon-pencil').css("display", "inline-block");
		}

		self.hideActionButtons = function() {
			$('.actionButtons').css("display", "none");
			$('body').find('td.actions .ui-icon-pencil').css("display", "none");
		}

		self.showEditCompetency = function() {
			$('#competenciesForm\\:competenciesPanel\\:competencies\\:0\\:competenciesRowEditor').find('span.ui-icon-pencil')
				.each(function() {
					$(this).click()
				})
		}

		self.updateNav = function(section) {
			if (section == 'competenciesPanel') {
				$('.competenciesPanel .competenciesTable .ui-paginator-prev').css('top', $(
					'.competenciesPanel .competenciesTable .ui-datatable-tablewrapper').height() / 2);
				$('.competenciesPanel .competenciesTable .ui-paginator-next').css('top', $(
					'.competenciesPanel .competenciesTable .ui-datatable-tablewrapper').height() / 2);
			}

			if (section == 'boardsPanel') {
				$('.boardsPanel .boardsTable .ui-paginator-prev').css('top', $(
					'.boardsPanel .boardsTable .ui-datatable-tablewrapper').height() / 2);
				$('.boardsPanel .boardsTable .ui-paginator-next').css('top', $(
					'.boardsPanel .boardsTable .ui-datatable-tablewrapper').height() / 2);
			}

			if (section == 'qualificationsPanel') {
				$('.qualificationsPanel .qualificationsTable .ui-paginator-prev').css('top', $(
					'.qualificationsPanel .qualificationsTable .ui-datatable-tablewrapper').height() / 2);
				$('.qualificationsPanel .qualificationsTable .ui-paginator-next').css('top', $(
					'.qualificationsPanel .qualificationsTable .ui-datatable-tablewrapper').height() / 2);
			}

			if (section == 'companiesPanel') {
				$('.companiesPanel .relationshipsTable .ui-paginator-prev').css('top', $(
					'.companiesPanel .relationshipsTable .ui-datatable-tablewrapper').height() / 2);
				$('.companiesPanel .relationshipsTable .ui-paginator-next').css('top', $(
					'.companiesPanel .relationshipsTable .ui-datatable-tablewrapper').height() / 2);
			}
		}

		self.hideAllFiltersOnLoad = function() {
			$(document).ready(function() {
				//Hide all filters on page load
				$(".ui-column-filter").css("display", "none");
				$('.competenciesShowLess').css("display", "none");
				$('.boardsShowLess').css("display", "none");				
				$('.qualificationsShowLess').css("display", "none");
				$('.relationshipsShowLess').css("display", "none");
                $('.talentManagementShowLess').css("display", "none");

			});
		}

        function setPagenater(select, number) {
            if (!_.find(select.find('option').map(function(i, e) {return e.value}).toArray(), function(e) {return e == number})) {
                number = select.find('option').last().val()
            }
            select.val(number).change()
        }

		self.update = function(section, number) {
			if (section == 'competencies') {
				setPagenater($('.competenciesTable select.ui-paginator-rpp-options'), number);
				if (number == 5) {
					$('.competenciesShowLess').css("display", "none");
					$('.competenciesShowMore').css("display", "block");
				} else {
					$('.competenciesShowMore').css("display", "none");
					$('.competenciesShowLess').css("display", "block");
				}
			}

            if (section == 'talentManagement') {
                setPagenater($('.talentManagementTable select.ui-paginator-rpp-options'), number);
                if (number == 5) {
                    $('.talentManagementShowLess').css("display", "none");
                    $('.talentManagementShowMore').css("display", "block");
                } else {
                    $('.talentManagementShowMore').css("display", "none");
                    $('.talentManagementShowLess').css("display", "block");
                }
            }

			if (section == 'boards') {
                setPagenater($('.boardsTable select.ui-paginator-rpp-options'), number);
				if (number == 5) {
					$('.boardsShowLess').css("display", "none");
					$('.boardsShowMore').css("display", "block");
				} else {
					$('.boardsShowMore').css("display", "none");
					$('.boardsShowLess').css("display", "block");
				}
			}			

			if (section == 'qualifications') {
                setPagenater($('.qualificationsTable select.ui-paginator-rpp-options'), number);
				if (number == 5) {
					$('.qualificationsShowLess').css("display", "none");
					$('.qualificationsShowMore').css("display", "block");
				} else {
					$('.qualificationsShowMore').css("display", "none");
					$('.qualificationsShowLess').css("display", "block");
				}
			}

			if (section == 'relationships') {
                setPagenater($('.relationshipsTable select.ui-paginator-rpp-options'), number);
				if (number == 5) {
					$('.relationshipsShowLess').css("display", "none");
					$('.relationshipsShowMore').css("display", "block");
				} else {
					$('.relationshipsShowMore').css("display", "none");
					$('.relationshipsShowLess').css("display", "block");
				}
			}
		}

		self.addIconTitle = function() {
			$('.ui-icon-check').attr("title", "Save");
			$('.ui-icon-close').attr("title", "Cancel");
		}

		self.attachExpandAction = function() {

			if (!$('.expandcollapse').prop('actionBound')) {

				$('.expandcollapse').prop('actionBound', true).click(function() {
                    self.onExpandCollapseExperienceClick($(this))
				});
			}
		}

        self.onExpandCollapseExperienceClick = function(source) {
            if ($(source).hasClass('competency')) {
                self.expandCollapseExperience(source, 'competenciesPanel');
            }

            if ($(source).hasClass('boards'))
            {

                self.expandCollapseExperience(source, 'boardsPanel');
            }

            if ($(source).hasClass('qualification')) {
                self.expandCollapseExperience(source, 'qualificationsPanel');
            }

            if ($(source).hasClass('relationship')) {
                self.expandCollapseExperience(source, 'companiesPanel');
            }

            if ($(source).hasClass('talentManagement')) {
                self.expandCollapseExperience(source, 'talentManagementPanel');
            }
        }


		self.expandCollapseExperience = function(elm, section) {
			var panelName = section;

			if ($(elm).hasClass('expanded')) {
				$(elm).removeClass('expanded');
				$('.' + panelName).removeClass('expanded');

				$('.alert').css("display", "block");
				$('.upgrade').css("display", "none");

				if (panelName == 'competenciesPanel') {
					self.update('competencies', 5);
					$('.qualificationsPanel').css("display", "block");
					$('.companiesPanel').css("display", "block");
					$('.boardsPanel').css("display", "block");
                    $('.talentManagementPanel').css("display", "block");
				}
				if (panelName == 'qualificationsPanel') {
					self.update('qualifications', 5);
					$('.competenciesPanel').css("display", "block");
					$('.companiesPanel').css("display", "block");
					$('.boardsPanel').css("display", "block");
                    $('.talentManagementPanel').css("display", "block");
				}
				if (panelName == 'companiesPanel') {
					self.update('relationships', 5);
					$('.competenciesPanel').css("display", "block");
					$('.qualificationsPanel').css("display", "block");
					$('.boardsPanel').css("display", "block");
                    $('.talentManagementPanel').css("display", "block");
				}
				if (panelName == 'boardsPanel') {
					self.update('boards', 5);
					$('.competenciesPanel').css("display", "block");
					$('.qualificationsPanel').css("display", "block");
					$('.companiesPanel').css("display", "block");
                    $('.talentManagementPanel').css("display", "block");
				}
                if (panelName == 'talentManagementPanel') {
                    self.update('talentManagement', 5);
                    $('.competenciesPanel').css("display", "block");
                    $('.qualificationsPanel').css("display", "block");
                    $('.companiesPanel').css("display", "block");
                    $('.boardsPanel').css("display", "block");
                }
                $('.' + panelName).css("width", "100%")
                    .css("left", "")
                    .css("right", "")
                    .css("padding-left", "");

				if ($('.' + panelName).find('table thead th').hasClass('filterEnabled')) {
					$('.' + panelName + ' .ui-column-filter').css("display", "inline-block");
				} else {
					$('.' + panelName + ' .ui-column-filter').css("display", "none");
				}
				$(elm).attr("src", self.resourcePath() + "/includes/modules/images/expand.png");
				$(elm).attr("title", "Expand");
			} else {
				$(elm).addClass('expanded');

				$('.alert').css("display", "none");
				$('.upgrade').css("display", "none");

				if (panelName == 'competenciesPanel') {
					remoteRefreshCompetency();
					$('.qualificationsPanel').css("display", "none");
					$('.companiesPanel').css("display", "none");
					$('.boardsPanel').css("display", "none");
                    $('.talentManagementPanel').css("display", "none");
				}
				if (panelName == 'boardsPanel') {
					remoteRefreshCompetency();
					$('.qualificationsPanel').css("display", "none");
					$('.companiesPanel').css("display", "none");
					$('.competenciesPanel').css("display", "none");
                    $('.talentManagementPanel').css("display", "none");
				}
				if (panelName == 'qualificationsPanel') {
					remoteRefreshQualification();
					$('.competenciesPanel').css("display", "none");
					$('.companiesPanel').css("display", "none");
					$('.boardsPanel').css("display", "none");
                    $('.talentManagementPanel').css("display", "none");
				}
				if (panelName == 'companiesPanel') {
					remoteRefreshCompany();
					$('.competenciesPanel').css("display", "none");
					$('.qualificationsPanel').css("display", "none");
					$('.boardsPanel').css("display", "none");
                    $('.talentManagementPanel').css("display", "none");
				}
                if (panelName == 'talentManagementPanel') {
                    remoteRefreshTalentManagement();
                    $('.qualificationsPanel').css("display", "none");
                    $('.companiesPanel').css("display", "none");
                    $('.boardsPanel').css("display", "none");
                    $('.competenciesPanel').css("display", "none");
                }

                $('.' + panelName).css("left", "0")
                    .css("right", "0")
                    .css("padding-left", "4px")
                    .css("width", "98.6%")
                    .addClass('expanded');

				if ($('.' + panelName).find('table thead th').hasClass('filterEnabled')) {
					$('.' + panelName + ' .ui-column-filter').css("display", "inline-block");
				} else {
					$('.' + panelName + ' .ui-column-filter').css("display", "none");
				}
				$(elm).attr("src", self.resourcePath() + "/includes/modules/images/collapse.png");
				$(elm).attr("title", "Collapse");
			}
		}

		self.closeAddCompetenciesOverlayPanel = function() {
			if (!$('#competenciesForm\\:competenciesPanel\\:competenciesInputTable').find('span.ui-message-error-detail').is(
				":visible")) {
				PF('addCompetenciesOverlayPanel').hide();
			}
		}

        self.closeAddTalentDetailOverlayPanel = function() {
            if (!$('#detailTalentCreatorForm\\:talentInputTable').find('span.ui-message-error-detail').is(
                    ":visible")) {
                PF('addDetailedTalentOverlayPanel').hide();
            }
        }


		self.showEditQualification = function() {
			$('#qualificationsForm\\:qualificationsPanel\\:qualifications\\:0\\:qualificationsRowEditor').find(
				'span.ui-icon-pencil').each(function() {
				$(this).click()
			})
		}

		self.showClearButton = function(rowIndexVar, calFieldId) {
			if ($('button.ui-datepicker-clear').length == 0) {
				$('.ui-datepicker-buttonpane').append(
					'<button class="ui-datepicker-clear ui-state-default ui-priority-primary ui-corner-all" onclick="mainVM.clearDate(' +
					rowIndexVar + ', &apos;' + calFieldId + '&apos;);">Clear</button>');
			}
		}

		self.clearDate = function(rowIndexVar, calFieldId) {
			var dateField = '#qualificationsForm\\:qualificationsPanel\\:qualifications\\:' + rowIndexVar + '\\:' +
				calFieldId + '_input';
			$(dateField).val(null);
		}
		self.windowclose = function() {
			if (!$('#qualificationsForm\\:qualificationsPanel\\:qualificationsInputTable').find(
				'span.ui-message-error-detail').is(":visible")) {
				PF('addQualificationOverlayPanel').hide();
			}
		}

		self.showClearButtonAdd = function(rowIndexVar, calFieldId) {
			if ($('button.ui-datepicker-clear').length == 0) {
				$('.ui-datepicker-buttonpane').append(
					'<button class="ui-datepicker-clear ui-state-default ui-priority-primary ui-corner-all" onclick="clearDateAdd(' +
					rowIndexVar + ', &apos;' + calFieldId + '&apos;);">Clear</button>');
			}
		}

		self.clearDateAdd = function(rowIndexVar, calFieldId) {
			var dateField = '#qualificationsForm\\:qualificationsPanel\\:qualificationsInputTable\\:' + rowIndexVar + '\\:' +
				calFieldId + '_input';
			$(dateField).val(null);
		}

        self.preventViewMode = function(dataTableWidgetVar) {
            PF(dataTableWidgetVar).viewMode = _.noop;
        }

        self.saveInCellCheckbox = function(source, table) {
            table.doCellEditRequest($(source).closest('td'), table)
        }
	});

})(jQuery);

window.mainVM = app.createVM("CandidateSkills")
